export enum Web3ActionsEnum {
  UPDATE_STATE = 'UPDATE_STATE',
  RESET_STATE = 'RESET_STATE',
}
